import styled from 'styled-components';

export const InfoCardWrapper = styled.div<{ backGroundColor?: string; isBorder?: boolean }>`
  display: flex;
  align-items: center;
  padding: 20px 16px;
  background-color: ${props => props.backGroundColor ?? props.theme.color.grey4};
  border-bottom: ${props => props.isBorder && `1px solid ${props.theme.color.alphaBackground}`};
  }
`;

export const CardInfo = styled.div`
  margin-left: 4px;
  & h5 {
    margin: 0;
  }

  & p {
    margin: 0;
  }
`;
